// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Montserrat/Montserrat-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Montserrat/Montserrat-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@font-face {
  font-family: "TempusFont";
  src: url("./fonts/dreaming-outloud-pro-script.otf") format("truetype"); 
  font-weight: normal;
  font-style: normal;
}
*/

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 100 900; /* Supports all weights */
  font-style: normal;
}

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 100 900;
  font-style: italic;
}

/* Apply globally or to specific elements */
body {
  font-family: "Montserrat", sans-serif;
}






body {
  margin: 0;
   
   font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif; 
  -webkit-font-smoothing: antialiased; 
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* index.css */
.react-calendar {
  height: 100% !important;
}
/* Reduce padding and margins */
.react-calendar {
  width: 250px !important; /* Smaller calendar width */
  max-width: 100%;
  font-size: 12px; /* Reduce font size */
}

.react-calendar__tile {
  padding: 4px !important; /* Reduce tile padding */
  font-size: 12px !important; /* Smaller button text */
}

.react-calendar__month-view__days__day {
  min-width: 24px !important;
  min-height: 24px !important;
}

/* Make navigation buttons smaller */
.react-calendar__navigation button {
  font-size: 12px !important;
  padding: 4px 6px !important;
  min-width: 24px !important;
}
/* Add your other global styles here */

/* Styles for the AssignedClientStats component */
.input-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.input-container h2 {
  margin-right: 10px;
}

input {
  padding: 5px;
  font-size: 1rem;
}


/* added ned font DreamingOutloudScriptPro */
/* @font-face {
  font-family: "Dreaming Outloud Script Pro";
  src: url("./fonts/DreamingOutloudScriptPro.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
} */


/* @font-face {
  font-family: "TempusFont";           
  src: url("./fonts/DreamingOutloudScriptPro.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
 */

/* @font-face {
  font-family: "TempusFont";
  src: url("./fonts/DreamingOutloudScriptPro.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
 */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAED;EACE,yBAAyB;EACzB,+DAAkF;EAClF,oBAAoB,EAAE,yBAAyB;EAC/C,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAyF;EACzF,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,qCAAqC;AACvC;;;;;;;AAOA;EACE,SAAS;;GAER;;cAEW;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,cAAc;AACd;EACE,uBAAuB;AACzB;AACA,+BAA+B;AAC/B;EACE,uBAAuB,EAAE,2BAA2B;EACpD,eAAe;EACf,eAAe,EAAE,qBAAqB;AACxC;;AAEA;EACE,uBAAuB,EAAE,wBAAwB;EACjD,0BAA0B,EAAE,wBAAwB;AACtD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA,sCAAsC;;AAEtC,iDAAiD;AACjD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;;AAGA,4CAA4C;AAC5C;;;;;GAKG;;;AAGH;;;;;;EAME;;AAEF;;;;;;EAME","sourcesContent":["/*@font-face {\n  font-family: \"TempusFont\";\n  src: url(\"./fonts/dreaming-outloud-pro-script.otf\") format(\"truetype\"); \n  font-weight: normal;\n  font-style: normal;\n}\n*/\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./fonts/Montserrat/Montserrat-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900; /* Supports all weights */\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./fonts/Montserrat/Montserrat-Italic-VariableFont_wght.ttf\") format(\"truetype\");\n  font-weight: 100 900;\n  font-style: italic;\n}\n\n/* Apply globally or to specific elements */\nbody {\n  font-family: \"Montserrat\", sans-serif;\n}\n\n\n\n\n\n\nbody {\n  margin: 0;\n   \n   font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif; \n  -webkit-font-smoothing: antialiased; \n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* index.css */\n.react-calendar {\n  height: 100% !important;\n}\n/* Reduce padding and margins */\n.react-calendar {\n  width: 250px !important; /* Smaller calendar width */\n  max-width: 100%;\n  font-size: 12px; /* Reduce font size */\n}\n\n.react-calendar__tile {\n  padding: 4px !important; /* Reduce tile padding */\n  font-size: 12px !important; /* Smaller button text */\n}\n\n.react-calendar__month-view__days__day {\n  min-width: 24px !important;\n  min-height: 24px !important;\n}\n\n/* Make navigation buttons smaller */\n.react-calendar__navigation button {\n  font-size: 12px !important;\n  padding: 4px 6px !important;\n  min-width: 24px !important;\n}\n/* Add your other global styles here */\n\n/* Styles for the AssignedClientStats component */\n.input-container {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.input-container h2 {\n  margin-right: 10px;\n}\n\ninput {\n  padding: 5px;\n  font-size: 1rem;\n}\n\n\n/* added ned font DreamingOutloudScriptPro */\n/* @font-face {\n  font-family: \"Dreaming Outloud Script Pro\";\n  src: url(\"./fonts/DreamingOutloudScriptPro.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n} */\n\n\n/* @font-face {\n  font-family: \"TempusFont\";           \n  src: url(\"./fonts/DreamingOutloudScriptPro.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n */\n\n/* @font-face {\n  font-family: \"TempusFont\";\n  src: url(\"./fonts/DreamingOutloudScriptPro.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
